// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { getLocationIcons } from './location-icons';

import { HighlightBox, Padding } from '../../../../../../commons/atoms';

export function PaymentLocations(): Node {
  return (
    <HighlightBox bordered>
      <Padding value="0 0 1em 0">
        <Padding value="1em">
          <p style={{fontSize: '0.86em'}}>Presente este cupon en cualquier tienda afiliada de PagosNet:</p>
        </Padding>
        <PaymentLocationIcons />
      </Padding>
    </HighlightBox>
  );
}

function PaymentLocationIcons(): Node {
  const locationIcons = getLocationIcons();

  return (
    <IconsWrapper>
      {locationIcons.map((element, index) => (
        <IconContainer key={index}>
          <Icon as="img" outline bordered src={element.imgSrc} alt={element.altText} />
        </IconContainer>
      ))}
    </IconsWrapper>
  );
}

const IconContainer = styled.div`
  width: 30%;
`;

const Icon = styled(HighlightBox)`
  width: 100%;
`;

const IconsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-evenly;
  align-content: space-evenly;
`;
